export function getSameOriginPath(value: string | null | undefined, fallback: string) {
  if (!value || typeof window === "undefined") return fallback;
  try {
    const url = new URL(value, window.location.origin);
    return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : fallback;
  } catch {
    return fallback;
  }
}
